import useSWR from 'swr';

import { useAsyncWrapper } from '../common/hooks-util';
import { CompanyUsersService, UsersService } from '../generated/tellus';

export const useListCompanyUsers = (
  companyKey: string,
  options: { isActive: boolean }
): {
  data: CompanyUser[] | undefined;
  loading: boolean;
  error: any;
  mutate: () => void;
} => {
  const { data, error, isLoading, mutate } = useSWR(
    { _key: 'ListCompanyUsers', companyKey, ...options },
    CompanyUsersService.listCompanyUsers
  );

  return { data, loading: isLoading, error, mutate };
};

export const useCreateCompanyUser = () => {
  return useAsyncWrapper(
    async (
      companyKey: string,
      data: {
        name: string;
        email: string;
        phoneNumber: string;
        sendInvitation: boolean;
        exportToQbis: boolean;
      }
    ) => {
      await CompanyUsersService.createCompanyUsers({
        companyKey,
        requestBody: data,
      });
    }
  );
};

export const useUpdateCompanyUser = () => {
  return useAsyncWrapper(
    async (
      companyKey: string,
      userId: string,
      update: { isActive?: boolean | null }
    ) => {
      await CompanyUsersService.updateCompanyUser({
        companyKey,
        userId,
        requestBody: update,
      });
    }
  );
};

export const useDeleteCompanyUser = () => {
  return useAsyncWrapper(async (companyKey: string, userId: string) => {
    await CompanyUsersService.deleteCompanyUser({ companyKey, userId });
  });
};

interface CompanyUser {
  id: string;
  name: string;
  email: string;
  phoneNumber: string;
  isInviteSent: boolean;
  hasLoggedIn: boolean;
  invitationMailStatus?: string | null;
  roles: CompanyUserRole[];
}

export const useListSystemUsers = (): {
  data: SystemUser[] | undefined;
  loading: boolean;
  error: any;
  mutate: () => void;
} => {
  const { data, error, isLoading, mutate } = useSWR(
    { _key: 'ListSystemUsers' },
    UsersService.listUsers
  );

  return { data, loading: isLoading, error, mutate };
};

export interface SystemUser {
  id: string;
  name: string;
  email: string;
  phoneNumber: string;
  companies: string[];
  roles: string[];
  isActive: boolean;
}

interface CompanyUserRole {
  role: string;
  scope?: string | null;
}
